import { TabsKeys } from "enums/ProductsViewEnums";

const isProductDisabled = (status?: string) => {

  if (!status) return false

  let isProductDisabled;

  switch (status) {
    case TabsKeys.IN_REVIEW:
    case TabsKeys.APPROVED:
      isProductDisabled = true
      break;

    case TabsKeys.DRAFT:
    case TabsKeys.DECLINED:
    default:
      isProductDisabled = false
  }

  return isProductDisabled

}

export default isProductDisabled